import { computed, ref } from "vue";
import { useNgSession } from "@sazka/ng/ng-session";
import { SlotsWinTable } from "../models/slots-win-table";
import { fetchSlotsWinTable } from "../api/bonusomat-player-data-api";

const { session } = useNgSession();
const playerId = computed(() => session.value?.PlayerID);

const slotsWinTable = ref<SlotsWinTable>(null);

async function loadSlotsWinTable() {
    slotsWinTable.value = await fetchSlotsWinTable(playerId.value);
}

export default function useBonusomatWinTables() {
    return {
        slotsWinTable,

        loadSlotsWinTable,
    };
}
